/**
 * MOULDING LIVE PRICE DISPLAY v2
 * Reads price band from product tags and displays live calculated price
 */
(function () {

  const MULTIPLIER = 4 / 15;
  const JOIN_ADJ   = 0.9375;
  const FLAT_FEE   = 2.00;

  const BAND_RATES = {
    'pc-01': 1.28, 'pc-02': 1.65, 'pc-03': 1.88, 'pc-04': 1.99,
    'pc-05': 2.25, 'pc-06': 2.47, 'pc-07': 2.91, 'pc-08': 3.08,
    'pc-09': 3.28, 'pc-10': 3.68, 'pc-11': 4.05, 'pc-12': 4.41,
    'pc-13': 4.60, 'pc-14': 4.76, 'pc-15': 4.90, 'pc-16': 5.03,
    'pc-17': 5.28, 'pc-18': 5.93, 'pc-19': 5.93, 'pc-20': 5.93,
    'pc-21': 6.38, 'pc-22': 6.48, 'pc-23': 6.80, 'pc-24': 7.14,
    'pc-25': 7.34, 'pc-26': 8.07, 'pc-27': 9.09, 'pc-28': 10.65,
    'pc-29': 10.37, 'pc-30': 17.06
  };

  function getBandRate(tags) {
    if (!tags) return null;
    var tagList = tags.toLowerCase().split(',');
    for (var i = 0; i < tagList.length; i++) {
      var tag = tagList[i].trim();
      var match = tag.match(/^chop-(pc-\d+)$/);
      if (match && BAND_RATES[match[1]] !== undefined) {
        return BAND_RATES[match[1]];
      }
    }
    return null;
  }

  function getSelectedVariantName() {
    // Try radio inputs first
    var checked = document.querySelector('.product-form__input input[type="radio"]:checked');
    if (checked) return checked.value.toLowerCase();

    // Try active/selected buttons
    var active = document.querySelector('.product-form__input .active, [aria-pressed="true"]');
    if (active) return active.textContent.trim().toLowerCase();

    // Try selected option label
    var selected = document.querySelector('.product-form__input label.selected, .product-form__input .selected label');
    if (selected) return selected.textContent.trim().toLowerCase();

    return '';
  }

  function updatePriceDisplay(price) {
    var els = document.querySelectorAll('.price-item.price-item--regular');
    els.forEach(function(el) {
      el.textContent = '$' + price.toFixed(2) + ' CAD';
    });
  }

  function resetPriceDisplay() {
    var els = document.querySelectorAll('.price-item.price-item--regular');
    els.forEach(function(el) {
      el.textContent = '$0.00 CAD';
    });
  }

  function recalculate(rate) {
    var variantName = getSelectedVariantName();
    var isChop = variantName.includes('chop');
    var isJoin = variantName.includes('join');

    if (!isChop && !isJoin) {
      resetPriceDisplay();
      return;
    }

    // Find the two dimension inputs inside Easify's container
    var inputs = document.querySelectorAll(
      '.easify-product-options input[type="number"], ' +
      '#easify input[type="number"], ' +
      '.easify input[type="number"]'
    );

    if (inputs.length < 2) return;

    var x = parseFloat(inputs[0].value) || 0;
    var y = parseFloat(inputs[1].value) || 0;

    if (x <= 0 || y <= 0) {
      resetPriceDisplay();
      return;
    }

    var effectiveRate = isJoin ? rate + JOIN_ADJ : rate;
    var price = effectiveRate * MULTIPLIER * (2.524 + x + y) + FLAT_FEE;
    updatePriceDisplay(price);
  }

  function init() {
    var dataEl = document.getElementById('moulding-calculator-data');
    if (!dataEl) return;

    var tags = dataEl.dataset.tags;
    var rate = getBandRate(tags);
    if (!rate) return;

    // Listen for dimension input changes
    document.addEventListener('input', function(e) {
      if (e.target.type === 'number') {
        recalculate(rate);
      }
    });

    // Listen for variant button clicks
    document.addEventListener('click', function(e) {
      var btn = e.target.closest('.product-form__input label, .product-form__input button');
      if (btn) {
        setTimeout(function() { recalculate(rate); }, 100);
      }
    });

    // Listen for variant radio/select changes
    document.addEventListener('change', function(e) {
      var input = e.target;
      if (input.closest('.product-form__input')) {
        setTimeout(function() { recalculate(rate); }, 50);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();